import type { ValidationErrors } from 'ngrx-forms';

export interface IsHouseNumberValidator {
  actual: any;
}

declare module 'ngrx-forms/src/state' {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  export interface ValidationErrors {
    isHouseNumber?: IsHouseNumberValidator;
  }
}

export const isHouseNumber = (value: string | undefined): ValidationErrors => {
  if (!value) {
    return { required: { actual: value } };
  }

  if (!/^\d+$/.test(value)) {
    return { notAnInteger: { actual: value } };
  }

  if (parseInt(value) <= 0) {
    return { mustBeGreaterThanZero: { actual: value } };
  }

  return {};
};
